import "../styles/common.scss";

// ------------------------------------------
// Headerの固定表示とスクロールでの表示/非表示切替
// ------------------------------------------
let isFixed = false;
let lastScrollY = 0;
let isHidden = false;
window.isMenuOpen = false;
window.isAutoScrolling = false;

function toggleFixedHeader() {
  const header = document.querySelector(".l-header");
  if (!header) return;

  const y = window.scrollY;

  // メニュー開いている間 or 自動スクロール中はヘッダーを必ず表示＆処理しない
  if (window.isMenuOpen || window.isAutoScrolling) {
    header.classList.remove("is-hidden"); 
    isHidden = false;
    lastScrollY = y; // スクロール位置だけは更新しておく
    return;
  }

  if (y > 100) {
    if (!isFixed) {
      header.classList.add("is-fixed");
      header.getBoundingClientRect();
      requestAnimationFrame(() => header.classList.add("is-fixed-enter"));
      isFixed = true;
    }

    if (y > lastScrollY && !isHidden) {
      header.classList.add("is-hidden");
      isHidden = true;
    } else if (y < lastScrollY && isHidden) {
      header.classList.remove("is-hidden");
      isHidden = false;
    }
  } else {
    header.classList.remove("is-fixed-enter", "is-fixed", "is-hidden");
    isFixed = false;
    isHidden = false;
  }

  lastScrollY = y;

  document.querySelector('.l-main').style.paddingTop = `${header.offsetHeight}px`;
}

window.addEventListener("scroll", toggleFixedHeader);
document.addEventListener("DOMContentLoaded", () =>
  requestAnimationFrame(toggleFixedHeader)
);


// ------------------------------------------
// ハンバーガーメニュー
// ------------------------------------------
document.addEventListener("DOMContentLoaded", () => {
  const button = document.querySelector(".js-button");
  const nav = document.querySelector("#nav");
  const header = document.querySelector(".l-header");

  if (!button || !nav) {
    console.warn("ハンバーガーメニュー要素が見つかりません。");
    return;
  }

  let isMenuOpen = false;

  function openMenu() {
    isMenuOpen = true;
    window.isMenuOpen = true;
    button.classList.add("is-open");
    button.setAttribute("aria-expanded", "true");
    nav.classList.add("is-open");

    if (header) {
      // メニューを開いた瞬間は必ず表示状態にする
      header.classList.remove("is-hidden");
      header.classList.add("is-open");
    }
    document.body.classList.add("is-fixed");
  }

  function closeMenu() {
    isMenuOpen = false;
    window.isMenuOpen = false;
    button.classList.remove("is-open");
    button.setAttribute("aria-expanded", "false");
    nav.classList.remove("is-open");

    if (header) {
      // 念のため .is-hidden も外しておく
      header.classList.remove("is-open");
      header.classList.remove("is-hidden");
    }
    document.body.classList.remove("is-fixed");
  }

  button.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isMenuOpen) { closeMenu(); } else { openMenu(); }

    // 範囲外クリックの誤反応防止
    document.removeEventListener("click", handleOutsideClick);
    setTimeout(() => {
      document.addEventListener("click", handleOutsideClick);
    }, 300);
  });

  function handleOutsideClick(e) {
    if (!isMenuOpen) return;
    if (!nav.contains(e.target) && !button.contains(e.target)) {
      closeMenu();
    }
  }

  //  - 自動スクロール中フラグを立てる
  //  - メニューを閉じる
  nav.addEventListener("click", (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const href = link.getAttribute("href");
    const targetId = href && href.startsWith("#") ? href.slice(1) : null;
    const targetEl = targetId ? document.getElementById(targetId) : null;

    if (targetEl) {
      window.isAutoScrolling = true;
      setTimeout(() => {
        window.isAutoScrolling = false;
      }, 600);
    }
    closeMenu();
  });
});


// --------------------
// Header toggle
// --------------------
document.addEventListener("DOMContentLoaded", function () {
  const headerToggle = document.querySelectorAll(".js-toggle");
  const mq = window.matchMedia("(max-width: 1024px)");

  function setEvent(enable) {
    headerToggle.forEach((btn) => {
      if (enable) {
        btn.addEventListener("click", toggleActive);
      } else {
        // イベントを削除
        btn.removeEventListener("click", toggleActive);
        btn.classList.remove("is-active");
      }
    });
  }

  function toggleActive(e) {
    const subtitle = e.currentTarget.querySelector('.subtitle');
    if (subtitle && subtitle.contains(e.target)) {
      e.preventDefault();
    }
    e.currentTarget.classList.toggle("is-active");
  }

  // 初期チェック
  setEvent(mq.matches);

  // 画面サイズ変更時にも反映
  mq.addEventListener("change", (e) => {
    setEvent(e.matches);
  });
});

// --------------------
// Footer Copyright
// --------------------
document.addEventListener("DOMContentLoaded", function() {
  const yearEls = document.querySelectorAll(".year");
  const currentYear = new Date().getFullYear();
  yearEls.forEach(el => {
    el.textContent = currentYear;
  });
});